/**
 * 自动生成的 MobX Mod 动态加载映射
 * 由 build-tools/mobx-mod-split-plugin.js 生成，请勿手动维护映射内容
 */

const ModuleMap = {
  'CheckOrderMod': () => import(
    /* webpackChunkName: "mod-CheckOrderMod" */
    'pages/Shop/CheckOrder/CheckOrderMod'
  ),
  'RegisterMod': () => import(
    /* webpackChunkName: "mod-RegisterMod" */
    'pages/Register/RegisterMod'
  ),
  'LoginMod': () => import(
    /* webpackChunkName: "mod-LoginMod" */
    'pages/Login/LoginMod'
  ),
  'PersonalMod': () => import(
    /* webpackChunkName: "mod-PersonalMod" */
    'pages/Shop/Member/Personal/PersonalMod'
  ),
  'ShoppingCartMod': () => import(
    /* webpackChunkName: "mod-ShoppingCartMod" */
    'pages/Shop/ShoppingCart/ShoppingCartMod'
  ),
  'NewAddMod': () => import(
    /* webpackChunkName: "mod-NewAddMod" */
    'pages/Promote/Schedule/NewAdd/NewAddMod'
  ),
  'BusinessCardMod': () => import(
    /* webpackChunkName: "mod-BusinessCardMod" */
    'pages/Promote/BusinessCard/BusinessCardMod'
  ),
  'AchievementMod': () => import(
    /* webpackChunkName: "mod-AchievementMod" */
    'pages/Promote/Achievement/AchievementMod'
  ),
  'AgreementsMod': () => import(
    /* webpackChunkName: "mod-AgreementsMod" */
    'pages/Shop/Member/Agreements/AgreementsMod'
  ),
  'AgentRegisterMod': () => import(
    /* webpackChunkName: "mod-AgentRegisterMod" */
    'pages/Shop/Member/Personal/AgentRegister/AgentRegisterMod'
  ),
  'MemCardMsgMod': () => import(
    /* webpackChunkName: "mod-MemCardMsgMod" */
    'pages/Register/MemCardMsg/MemCardMsgMod'
  ),
  'DetailMod': () => import(
    /* webpackChunkName: "mod-DetailMod" */
    'pages/Shop/Member/TradeManage/OrderList/Detail/DetailMod'
  ),
  'NomalWalletMod': () => import(
    /* webpackChunkName: "mod-NomalWalletMod" */
    'pages/Shop/Member/Wallet/NomalWallet/NomalWalletMod'
  ),
  'QuickBuyMod': () => import(
    /* webpackChunkName: "mod-QuickBuyMod" */
    'pages/Shop/Member/TradeManage/QuickBuy/QuickBuyMod'
  ),
  'QuickBuyForCouponMod': () => import(
    /* webpackChunkName: "mod-QuickBuyForCouponMod" */
    'pages/Shop/Member/TradeManage/QuickBuyForCoupon/QuickBuyMod'
  ),
  'ApplyAfterSaleMod': () => import(
    /* webpackChunkName: "mod-ApplyAfterSaleMod" */
    'pages/Shop/Member/TradeManage/AfterSale/ApplyAfterSale/ApplyAfterSaleMod'
  ),
  'OrderSwitchMod': () => import(
    /* webpackChunkName: "mod-OrderSwitchMod" */
    'pages/Shop/Member/TradeManage/OrderSwitch/OrderSwitchMod'
  ),
  'RegisterStoreMod': () => import(
    /* webpackChunkName: "mod-RegisterStoreMod" */
    'pages/Register/RegisterStore/RegisterStoreMod'
  ),
  'StudioMsgMod': () => import(
    /* webpackChunkName: "mod-StudioMsgMod" */
    'pages/Register/StudioMsg/StudioMsgMod'
  ),
  'StoreAgentRegisterMod': () => import(
    /* webpackChunkName: "mod-StoreAgentRegisterMod" */
    'pages/Store/BusinessManage/AgentRegister/AgentRegisterMod'
  ),
  'StoreAgentMsgMod': () => import(
    /* webpackChunkName: "mod-StoreAgentMsgMod" */
    'pages/Store/BusinessManage/StoreAgentMsg/StoreAgentMsgMod'
  ),
  'MemberBirthdayMod': () => import(
    /* webpackChunkName: "mod-MemberBirthdayMod" */
    'pages/Shop/Home/MemberBirthday/MemberBirthdayMod'
  ),
  'BuyModalMod': () => import(
    /* webpackChunkName: "mod-BuyModalMod" */
    'pages/Learn/component/BuyMadol/BuyModalMod'
  ),
  'CertificatesMod': () => import(
    /* webpackChunkName: "mod-CertificatesMod" */
    'pages/Shop/Member/Personal/Certificates/CertificatesMod'
  ),
  'FormulaMod': () => import(
    /* webpackChunkName: "mod-FormulaMod" */
    'pages/Shop/Formula/FormulaMod'
  ),
  'FreeShippingMod': () => import(
    /* webpackChunkName: "mod-FreeShippingMod" */
    'pages/Shop/Product/FreeShipping/FreeShippingMod'
  ),
  'SicknessMod': () => import(
    /* webpackChunkName: "mod-SicknessMod" */
    'pages/Shop/Member/Personal/Sickness/SicknessMod'
  ),
  'QuestionnaireMod': () => import(
    /* webpackChunkName: "mod-QuestionnaireMod" */
    'pages/Shop/Member/Questionnaire/QuestionnaireMod'
  ),
  'DetailedListMod': () => import(
    /* webpackChunkName: "mod-DetailedListMod" */
    'pages/Promote/Schedule/DetailedList/DetailedListMod'
  ),
  'CommentMod': () => import(
    /* webpackChunkName: "mod-CommentMod" */
    'widget/Comment/CommentMod'
  ),
  'BusinessCard': () => import(
    /* webpackChunkName: "mod-BusinessCard" */
    'pubBiz/BusinessCard/indexMod'
  ),
  'ActiveAdPopupMod': () => import(
    /* webpackChunkName: "mod-ActiveAdPopupMod" */
    'pubBiz/ActiveAdPopup/indexMod'
  ),
  'RemindCustomerMod': () => import(
    /* webpackChunkName: "mod-RemindCustomerMod" */
    'pages/Promote/Schedule/NewAdd/RemindCustomer/RemindCustomerMod'
  ),
  'MsgAddMod': () => import(
    /* webpackChunkName: "mod-MsgAddMod" */
    'pages/Shop/Member/MsgAdd/MsgAddMod'
  ),
  'ProductListMod': () => import(
    /* webpackChunkName: "mod-ProductListMod" */
    'pages/Shop/Product/ProductList/ProductListMod'
  ),
  'QualificationMod': () => import(
    /* webpackChunkName: "mod-QualificationMod" */
    'pages/Shop/Product/Qualification/QualificationMod'
  ),
  'QualificationPageMod': () => import(
    /* webpackChunkName: "mod-QualificationPageMod" */
    'pages/Shop/Product/QualificationPage/QualificationPageMod'
  ),
  'ProtectionMod': () => import(
    /* webpackChunkName: "mod-ProtectionMod" */
    'pages/Shop/Member/Personal/Protection/ProtectionMod'
  ),
  'ProfitSharingMod': () => import(
    /* webpackChunkName: "mod-ProfitSharingMod" */
    'pages/Shop/Member/Personal/ProfitSharing/ProfitSharingMod'
  ),
  'ProfitSharBindMod': () => import(
    /* webpackChunkName: "mod-ProfitSharBindMod" */
    'pages/Shop/Member/Personal/ProfitSharing/ProfitSharBind/ProfitSharBindMod'
  ),
  'CisternWalletMod': () => import(
    /* webpackChunkName: "mod-CisternWalletMod" */
    'pages/Shop/Member/Wallet/CisternWallet/CisternWalletMod'
  ),
  'BonusWalletMod': () => import(
    /* webpackChunkName: "mod-BonusWalletMod" */
    'pages/Shop/Member/Wallet/BonusWallet/BonusWalletMod'
  ),
  'ScoreMod': () => import(
    /* webpackChunkName: "mod-ScoreMod" */
    'pages/Shop/Member/Wallet/Score/ScoreMod'
  ),
  'ProductDetailMod': () => import(
    /* webpackChunkName: "mod-ProductDetailMod" */
    'pages/Shop/Product/ProductDetail/ProductDetailMod'
  ),
  'StoreCardMsgMod': () => import(
    /* webpackChunkName: "mod-StoreCardMsgMod" */
    'pages/Register/StoreCardMsg/StoreCardMsgMod'
  ),
  'StoreWalletMod': () => import(
    /* webpackChunkName: "mod-StoreWalletMod" */
    'pages/Store/Wallet/StoreWallet/StoreWallettMod'
  ),
  'AccountMod': () => import(
    /* webpackChunkName: "mod-AccountMod" */
    'pages/Shop/Member/Personal/Account/AccountMod'
  ),
  'ViewPackageMod': () => import(
    /* webpackChunkName: "mod-ViewPackageMod" */
    'pages/Register/ViewPackage/ViewPackageMod'
  )
};

export async function loadMod(modName) {
  const loader = ModuleMap[modName];
  if (!loader) {
    throw new Error(`Mod "${modName}" 不存在于 ModuleMap 中`);
  }

  const mod = await loader();
  return mod.default || mod;
}

export async function loadMods(modNames) {
  const loaded = await Promise.all(
    modNames.map((modName) =>
      loadMod(modName).then((mod) => ({
        modName,
        mod
      }))
    )
  );

  return loaded.reduce((result, item) => {
    result[item.modName] = item.mod;
    return result;
  }, {});
}

export function getAvailableModNames() {
  return Object.keys(ModuleMap);
}

export default ModuleMap;



// WEBPACK FOOTER //
// ./src/config/ModuleMap.js